import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListeCaches = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"listeCaches"}/>
        </div>
    );
}
export default ListeCaches;